import { UpdatableNotificationInternal, UpdatePayload } from '../../../client/internal';
import { getMarkdownTextContent } from '../../view/utils/Markdown';
import { TemplateMarkdown, UpdatableNotificationOptions } from '../../../client/templates';
import { isTemplate } from '../../model/templates/isTemplate';
import { getTemplateSchema } from '../../model/templates/updateSchemas';
import { ValidateOptions } from 'yup/lib/types';

export function hydrateUpdateNotification<T extends UpdatableNotificationOptions>(
  payload: UpdatePayload<UpdatableNotificationOptions>,
  options?: ValidateOptions
): UpdatableNotificationInternal<T> {
  const schema = getTemplateSchema(payload);

  const updatedNotification: UpdatableNotificationInternal<T> = (schema.validateSync(
    payload,
    options
  ) as unknown) as UpdatableNotificationInternal<T>;

  const bodyText = isTemplate<TemplateMarkdown>(updatedNotification, 'markdown')
    ? getMarkdownTextContent(updatedNotification.body)
    : '';

  return {
    ...updatedNotification,
    bodyText,
    body: updatedNotification.body,
  };
}
